module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust3_m_en.ae1d6ecaa8c1832680854eb6e6fdba76.png";